import { Text } from 'ui-kit/typography'
import { integrationData, ipaasData } from './tablesData'
import clsx from 'clsx'
import classes from './DifferenceTable.module.scss'

export const DifferenceTable = ({ status }: { status: boolean }) => {
  const checkArray = () => {
    return status ? integrationData : ipaasData
  }

  const checkNumber = (number: number) => {
    if (number >= 1 && number <= 10) return 'data__green'
    if (number > 10 && number <= 99) return 'data__yellow'
    return 'data__red'
  }

  return (
    <table className={classes.table}>
      <thead>
        <tr>
          <th
            scope='col'
            rowSpan={2}
            className={clsx(classes.cell, classes.caption)}
          >
            &nbsp;
          </th>
          <th
            scope='col'
            rowSpan={2}
            className={clsx(classes.cell, classes.column_data)}
          >
            &nbsp;
          </th>
          <th
            scope='col'
            colSpan={4}
            className={clsx(classes.cell, classes.title_column)}
          >
            <Text as={'span'} size={'xs'} className={classes.text}>
              Number of Integration Scenarios
            </Text>
          </th>
        </tr>
        <tr className={classes.row_data}>
          <th scope='col' className={classes.cell}>
            1
          </th>
          <th scope='col' className={classes.cell}>
            2
          </th>
          <th scope='col' className={classes.cell}>
            5
          </th>
          <th scope='col' className={classes.cell}>
            10
          </th>
        </tr>
      </thead>
      <tbody>
        {checkArray().map(({ colHead, col1, col2, col3, col4 }, idx) => {
          if (idx === 0) {
            return (
              <tr key={idx}>
                <th
                  scope='row'
                  rowSpan={5}
                  className={clsx(classes.cell, classes.title_row)}
                >
                  <Text as={'span'} size={'xs'} className={classes.text}>
                    Number of external apps
                  </Text>
                </th>
                <th scope='row' className={classes.cell}>
                  {colHead}
                </th>
                <td
                  className={clsx(
                    classes.cell,
                    classes.data,
                    classes[checkNumber(col1)],
                  )}
                >
                  {col1}
                </td>
                <td
                  className={clsx(
                    classes.cell,
                    classes.data,
                    classes[checkNumber(col2)],
                  )}
                >
                  {col2}
                </td>
                <td
                  className={clsx(
                    classes.cell,
                    classes.data,
                    classes[checkNumber(col3)],
                  )}
                >
                  {col3}
                </td>
                <td
                  className={clsx(
                    classes.cell,
                    classes.data,
                    classes[checkNumber(col4)],
                  )}
                >
                  {col4}
                </td>
              </tr>
            )
          }
          return (
            <tr key={idx}>
              <th scope='row' className={classes.cell}>
                {colHead}
              </th>
              <td
                className={clsx(
                  classes.cell,
                  classes.data,
                  classes[checkNumber(col1)],
                )}
              >
                {col1}
              </td>
              <td
                className={clsx(
                  classes.cell,
                  classes.data,
                  classes[checkNumber(col2)],
                )}
              >
                {col2}
              </td>
              <td
                className={clsx(
                  classes.cell,
                  classes.data,
                  classes[checkNumber(col3)],
                )}
              >
                {col3}
              </td>
              <td
                className={clsx(
                  classes.cell,
                  classes.data,
                  classes[checkNumber(col4)],
                )}
              >
                {col4}
              </td>
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}
